import { getImagePath } from '../../../Utils/assetUtils';
import { logoBaseURL } from '../../../Utils/constants';

/**
 * Image error handler that sets a fallback image, with guard against infinite loops.
 */
export const handleImageError = (event: any, fallbackPath = 'images/bank-default.svg') => {
  const fallback = getImagePath(fallbackPath);
  if (!event.target.src.endsWith(fallback)) {
    event.target.src = fallback;
  }
};

/**
 * Returns the logo URL for a given FIP ID, or the default fallback image.
 */
export const getBankLogoSrc = (fipId?: string | null): string => {
  if (fipId != null && fipId !== '') {
    return `${logoBaseURL}${fipId}.jpeg`;
  }
  return getImagePath('images/bank-default.svg');
};

/**
 * Returns the logo URL for a stock, trying logo first, then ISIN, then fallback.
 */
export const getStockLogoSrc = (logo?: string | null, isin?: string | null): string => {
  if (logo != null && logo !== '') {
    return `https://logo.ignosis.ai/equity/${logo}`;
  }
  if (isin != null && isin !== '') {
    return `https://logo.ignosis.ai/equity/${isin}.png`;
  }
  return getImagePath('images/bank-default.svg');
};
